export default __webpack_public_path__ + "static/media/PenzugyiForrasok.62453fd7.jpg";